<template>
    <div class="home-container">
        <v-container fluid class="fill-height">
            <v-row justify="center" align="center" class="fill-height">
                <v-col cols="12" md="8" lg="6" class="text-center">
                    <v-card class="pa-8 elevation-8" color="primary" dark>
                        <v-card-title class="justify-center mb-4">
                            <v-icon size="80" class="mb-4"
                                >mdi-diamond-stone</v-icon
                            >
                        </v-card-title>

                        <v-card-title class="justify-center">
                            <h1 class="display-1 font-weight-bold text-center">
                                أهلا بك في تطبيق جوهرة سما بابل
                            </h1>
                        </v-card-title>

                        <v-card-text class="text-center mt-4">
                            <p class="headline font-weight-light">
                                نظام إدارة شركة جوهرة سما بابل للاستثمار
                            </p>
                            <p class="title mt-4">
                                مرحباً {{ userName || "مستخدم" }}
                            </p>
                        </v-card-text>

                        <v-card-actions class="justify-center mt-6">
                            <v-btn
                                large
                                outlined
                                color="white"
                                @click="navigateToFirstAvailablePage"
                                class="mx-2"
                            >
                                <v-icon left>mdi-arrow-right</v-icon>
                                ابدأ الاستخدام
                            </v-btn>
                        </v-card-actions>
                    </v-card>

                    <v-row class="mt-8" justify="center">
                        <v-col cols="12" sm="6" md="4" v-if="isAdmin()">
                            <v-card class="pa-4" elevation="2">
                                <v-card-title class="justify-center">
                                    <v-icon color="warning" size="40"
                                        >mdi-crown</v-icon
                                    >
                                </v-card-title>
                                <v-card-text class="text-center">
                                    <h3>صلاحيات إدارية</h3>
                                    <p>لديك صلاحيات كاملة للنظام</p>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-card class="pa-4" elevation="2">
                                <v-card-title class="justify-center">
                                    <v-icon color="success" size="40"
                                        >mdi-shield-check</v-icon
                                    >
                                </v-card-title>
                                <v-card-text class="text-center">
                                    <h3>نظام آمن</h3>
                                    <p>حماية شاملة لبياناتك</p>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-card class="pa-4" elevation="2">
                                <v-card-title class="justify-center">
                                    <v-icon color="info" size="40"
                                        >mdi-chart-line</v-icon
                                    >
                                </v-card-title>
                                <v-card-text class="text-center">
                                    <h3>إدارة الاستثمارات</h3>
                                    <p>تتبع شامل لجميع العمليات</p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import roleAuthMixin from "@/mixins/roleAuth";
import { Roles } from "@/utils/roles";

export default {
    name: "HomePage",
    mixins: [roleAuthMixin],

    computed: {
        userName() {
            return (
                this.$store.state.auth.userData?.userData?.fullName ||
                this.$store.state.auth.userData?.fullName ||
                this.$store.state.auth.decodedToken?.name ||
                "مستخدم"
            );
        },
    },

    methods: {
        navigateToFirstAvailablePage() {
            // Navigate to the first available page based on user roles
            if (this.hasRole([Roles.Admin, Roles.SuperAdmin])) {
                this.$router.push("/admin");
            } else if (this.hasRole(Roles.Administrator)) {
                this.$router.push("/users");
            } else if (this.hasRole([Roles.Manager, Roles.Investor])) {
                this.$router.push("/Investments");
            } else {
                // Default to branches if no specific role found
                this.$router.push("/branches");
            }
        },
    },
};
</script>

<style scoped>
.home-container {
    min-height: 100vh;
    /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
}

.v-card {
    border-radius: 20px;
}

.display-1 {
    line-height: 1.2;
}

@media (max-width: 600px) {
    .display-1 {
        font-size: 2rem !important;
    }
}
</style>
